module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline pb-0"
  }, [_vm._v("\n    Online meeting details\n    "), _c('v-spacer'), _vm._v(" "), (_vm.withedit) ? [(!_vm.editmode) ? _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.editmode = true
      }
    }
  }, [_vm._v("Edit")]) : _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.editmode = false
      }
    }
  }, [_vm._v("Cancel")])] : _vm._e()], 2), _vm._v(" "), (!_vm.editmode) ? _c('v-card-text', [(_vm.appointment.zoom_meeting_id) ? [_c('strong', [_vm._v("Meeting ID:")]), _vm._v("\n        " + _vm._s(_vm.appointment.zoom_meeting_id) + "\n      ")] : _vm._e(), _vm._v(" "), (_vm.appointment.zoom_join_url) ? _c('copy-text-field', {
    attrs: {
      "label": "Meeting join url",
      "text-to-copy": _vm.appointment.zoom_join_url,
      "hint": "Your customer will use this to join the meeting"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.appointment.zoom_meeting_password) ? _c('copy-text-field', {
    attrs: {
      "label": "Meeting password",
      "text-to-copy": _vm.appointment.zoom_meeting_password,
      "hint": "The password for this meeting"
    }
  }) : _vm._e()], 2) : _c('v-card-text', [_c('manual-online-meeting-form', {
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  })], 1), _vm._v(" "), (_vm.appointment.zoom_meeting_id) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "href": ("https://zoom.us/meeting/" + (_vm.appointment.zoom_meeting_id)),
      "target": "_blank"
    }
  }, [_vm._v("\n      View meeting\n      "), _c('v-icon', {
    staticClass: "ml-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "href": _vm.appointment.zoom_start_url,
      "color": "primary",
      "target": "_blank"
    }
  }, [_vm._v("\n      Start meeting\n      "), _c('v-icon', {
    staticClass: "ml-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65a16106","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/OnlineMeetingCard.vue
// module id = 1450
// module chunks = 9